export const tryGetBrand = (path: string): { brand: string | undefined; category: string | undefined } | null => {
  const urlParts = path.split('/').filter((_) => _);
  //when on brand store we don't need to fetch brand, only retailer
  if (urlParts.length > 1 && urlParts.at(0) === 'brands' && urlParts.at(0) !== 'brand-store') {
    const [, brand, category] = urlParts;
    return { brand, category };
  }
  return null;
};

export const tryGetRetailer = (path: string): { retailer: string | undefined } | null => {
  const urlParts = path.split('/').filter((_) => _);
  if (urlParts.length > 1 && (urlParts.at(0) === 'online-shops' || urlParts.at(0) === 'brand-store')) {
    const [, retailer] = urlParts;

    return { retailer };
  }
  return null;
};

export function findDuplicateElementsByName(arr: { name: string }[]) {
  const duplicates: { name: string }[] = [];
  const names = new Set();

  for (const obj of arr) {
    if (names.has(obj.name)) duplicates.push(obj);
    else names.add(obj.name);
  }

  return duplicates;
}

export function mergeDuplicateCategories(
  duplicates: { name: string }[],
  ret: { name: any; count: number; checked: boolean; id: string; value: string }[]
) {
  const duplicatesWithValues = duplicates.map((_) => {
    return {
      [_.name]: ret.filter((retItem) => retItem.name === _.name),
    };
  });

  const mergedCategories = duplicatesWithValues.map((_) => {
    const categoriesToMerge = Object.values(_).flat();

    const [element] = categoriesToMerge;

    const values = categoriesToMerge.map((_) => _.value).join(',');
    const totalCount = categoriesToMerge.reduce(
      (previousValue, currentValue) => previousValue + Number(currentValue.count),
      0
    );

    const anySelected = categoriesToMerge.some((_) => _.checked);

    return {
      id: element.id,
      name: element.name,
      value: values,
      count: totalCount,
      checked: anySelected,
    };
  });

  const originalFiltered = ret.filter((_) => !duplicates.find((duplicate) => duplicate.name === _.name));

  return originalFiltered.concat(mergedCategories);
}

//TODO dsantic 07.06.2024. I guess this one should be places in correct place
export function checkIsProductLine(pageTags: string | undefined, productLines: string[], brand?: string) {
  if (!productLines || !pageTags || (pageTags === 'blazer' && brand !== 'nike')) return false;
  return !pageTags ? false : productLines.includes(pageTags);
}

export function getProductColorValue(colors: string[]) {
  if (colors && colors.length > 0) {
    if (typeof colors[0] === 'string') {
      return colors[0].capitalizeWords();
    }
    return colors[0];
  }
  return '';
}
